module.exports = __webpack_public_path__ + "img/Polos.b896ac67.png";